<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <div class="flex justify-center">
        <div class="w-auto h-12 flex items-center">
          <h1 class="text-3xl font-bold text-gray-900">Meal Mate</h1>
        </div>
      </div>
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        {{ title }}
      </h2>
      <p v-if="subtitle" class="mt-2 text-center text-sm text-gray-600">
        {{ subtitle }}
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <slot />
      </div>
      
      <div v-if="showFooterLinks" class="mt-6">
        <div class="text-center">
          <slot name="footer-links" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string
  subtitle?: string
  showFooterLinks?: boolean
}

withDefaults(defineProps<Props>(), {
  subtitle: '',
  showFooterLinks: true
})
</script>
